export const shipperNavConfig = [
  // Quotes
  {
    id: 'quotationManagement',
    title: 'Quotes',
    messageId: 'sidebar.quotationManagement',
    type: 'item',
    icon: ['/assets/images/sideMenu/quotes-active.png', '/assets/images/sideMenu/quotes.png'],
    role: ['ROLE_CONSIGNEE'],
    url: ['/shipper/quotation/create',
      '/shipper/quotation/price',
      '/shipper/quotation/Airfreight-quote/price',
      '/shipper/quotation/list/view',
      '/shipper/quotation/details/'
    ],
    // children: [
    //   {
    //     id: 'quotationCreate',
    //     title: 'New Quote',
    //     messageId: 'sidebar.quotationManagement.quotationCreate',
    //     type: 'item',
    //     url: '/shipper/quotation/create',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    //   {
    //     id: 'quotationList',
    //     title: 'My Quotes',
    //     messageId: 'sidebar.quotationManagement.quotationList',
    //     type: 'item',
    //     url: '/shipper/quotation/list/view',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    // ],
  },

  // Tracking
  // {
  //   id: 'trackingManagement',
  //   title: 'Tracking',
  //   messageId: 'sidebar.trackingManagement',
  //   type: 'collapse',
  //   icon: '/assets/images/sideMenu/tracking.png',
  //   role: ['ROLE_CONSIGNEE'],
  //   children: [],
  // },

  // Freight Forwarders
  {
    id: 'freightForwarders',
    title: 'Freight Forwarders',
    messageId: 'sidebar.freightForwarders',
    type: 'item',
    icon: ['/assets/images/sideMenu/freight-forwarder-active.png', '/assets/images/sideMenu/freight-forwarder.png'],
    role: ['ROLE_CONSIGNEE'],
    url: ['/shipper/freight-forwarders/sent/requests/list/view',
      '/shipper/freight-forwarders/sent/requests/list/view',
      '/shipper/freight-forwarders/request/send',
      '/shipper/freight-forwarder/company-details/',
      '/shipper/freight-forwarders/message/list/view',],
    // children: [
    //   {
    //     id: 'sentRequests',
    //     title: 'Sent Requests',
    //     messageId: 'sidebar.sentRequests',
    //     type: 'item',
    //     url: '/shipper/freight-forwarders/sent/requests/list/view',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    //   {
    //     id: 'sendRequest',
    //     title: 'Send Request',
    //     messageId: 'sidebar.sendRequest',
    //     type: 'item',
    //     url: '/shipper/freight-forwarders/request/send',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    // ],
  },

  // Address Book
  // {
  //   id: 'addressManagement',
  //   title: 'Address Book',
  //   messageId: 'sidebar.addressManagement',
  //   type: 'item',
  //   icon: ['/assets/images/sideMenu/address-book-active.png', '/assets/images/sideMenu/address-book.png'],
  //   role: ['ROLE_CONSIGNEE'],
  //   url: ['/shipper/directory/address/new',
  //     '/shipper/directory/address/list/view',
  //     '/shipper/directory/address/edit/'],
  //   // children: [
  //   //   {
  //   //     id: 'addAddress',
  //   //     title: 'Add Address',
  //   //     messageId: 'sidebar.addressManagement.addAddress',
  //   //     type: 'item',
  //   //     url: '/shipper/directory/address/new',
  //   //     icon: '/assets/images/sideMenu/sub-menu.png',
  //   //   },
  //   //   {
  //   //     id: 'customerList',
  //   //     title: 'Address List',
  //   //     messageId: 'sidebar.addressManagement.addressList',
  //   //     type: 'item',
  //   //     url: '/shipper/directory/address/list/view',
  //   //     icon: '/assets/images/sideMenu/sub-menu.png',
  //   //   },
  //   // ],
  // },

  // Statistics
  // {
  //   id: 'statistics',
  //   title: 'Statistics',
  //   messageId: 'sidebar.statistics',
  //   type: 'item',
  //   icon: ['/assets/images/sideMenu/statistics-active.png', '/assets/images/sideMenu/statistics.png'],
  //   role: ['ROLE_CONSIGNEE'],
  //   url: ['/shipper/statistics'],
  //   // children: [
  //   //   {
  //   //     id: 'statistics',
  //   //     title: 'Statistics',
  //   //     messageId: 'sidebar.statistics.statistics',
  //   //     type: 'item',
  //   //     url: '/shipper/statistics',
  //   //     icon: '/assets/images/sideMenu/sub-menu.png',
  //   //   },
  //   // ],
  // },

  // Settings
  {
    id: 'profileManagement',
    title: 'Settings',
    messageId: 'sidebar.profile',
    type: 'item',
    icon: ['/assets/images/sideMenu/settings-active.png', '/assets/images/sideMenu/settings.png'],
    role: ['ROLE_CONSIGNEE'],
    url: ['/shipper/profile/update1',
      '/shipper/profile//measurements/system'],
    // children: [
    //   {
    //     id: 'profile',
    //     title: 'View Profile',
    //     messageId: 'sidebar.adminProfile.update',
    //     type: 'item',
    //     url: '/shipper/profile/update1',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    // ],
  },


  // Documents
  // {
  //   id: 'documentsManagement',
  //   title: 'Documents',
  //   messageId: 'sidebar.documentsManagement',
  //   type: 'collapse',
  //   icon: '/assets/images/sideMenu/documents.png',
  //   role: ['ROLE_CONSIGNEE'],
  //   children: [],
  // },

  // Notifications
  {
    id: 'notification',
    title: 'Notifications',
    messageId: 'sidebar.notification',
    type: 'item',
    icon: ['/assets/images/sideMenu/notification-active.png', '/assets/images/sideMenu/notification.png'],
    role: ['ROLE_CONSIGNEE'],
    url: ['/shipper/notification'],
    // children: [
    //   {
    //     id: 'notification',
    //     title: 'Notifications',
    //     messageId: 'sidebar.notification',
    //     type: 'item',
    //     url: '/shipper/notification',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    // ],
  },

  // Feedback
  {
    id: 'feedBackManagement',
    title: 'Feedback',
    messageId: 'sidebar.feedBackManagement',
    type: 'item',
    icon: ['/assets/images/sideMenu/feedback-active.png', '/assets/images/sideMenu/feedback.png'],
    role: ['ROLE_CONSIGNEE'],
    url: ['/shipper/addfeedback',
      '/shipper/feedback/view',
      '/freight-forwarder/Shipper/feedback/feedbacklist/view/'],
    // children: [
    //   {
    //     id: 'feedback',
    //     title: 'Feedback',
    //     messageId: 'sidebar.feedBackManagement.feedback',
    //     type: 'item',
    //     url: '/shipper/feedback/view',
    //     icon: '/assets/images/sideMenu/sub-menu.png',
    //   },
    // ],
  },

  // Tutorial
  {
    id: 'ytTutorial',
    title: 'Tutorial',
    messageId: 'sidebar.ytTutorial',
    type: 'item',
    icon: ['/assets/images/sideMenu/youtube-active.png', '/assets/images/sideMenu/youtube.png'],
    url: ['/freight-forwarder/Shipper/tutorial/view'],
    role: ['ROLE_CONSIGNEE'],
  },
];